require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-aweary-reason-vue.json") })
        }
      }, "path---package-unpublished-aweary-reason-vue");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-aweary-reason-vue!./.cache/json/package-unpublished-aweary-reason-vue.json
// module id = 932
// module chunks = 231608221292675